// 02.3-client.md paso b -- lookup tables puras extraídas de SubPanelTratos.jsx (mismo
// tratamiento que features/map/lib/mapDraw.js para lógica pura no-componente). Las claves son
// nombres reales de campos/tipos de documento de la DB/API (`nombre_negocio`, `correo`, `acta`,
// `csf`, etc.) -- no se traducen ni se cambian, la regla de identificadores en inglés de
// CLAUDE.md es prospectiva, no una barrida retroactiva.

const FIELD_FRIENDLY_NAMES = {
    nombre_negocio: 'Nombre de Negocio',
    correo: 'Correo',
    telefono: 'Número de Teléfono',
    direccion: 'Dirección',
    giro: 'Giro Comercial',
    representante: 'Representante Legal',
    ingreso_mensual: 'Ingreso Mensual',
    ticket_promedio: 'Ticket Promedio',
    moneda_usd: 'Moneda (USD)',
    moneda_mxn: 'Moneda (MXN)',
    contacto_1_nombre: 'Contacto 1: Nombre',
    contacto_1_correo: 'Contacto 1: Correo',
    contacto_1_tel: 'Contacto 1: Teléfono',
    contacto_2_nombre: 'Contacto 2: Nombre',
    contacto_2_correo: 'Contacto 2: Correo',
    contacto_2_tel: 'Contacto 2: Teléfono',
    contacto_3_nombre: 'Contacto 3: Nombre',
    contacto_3_correo: 'Contacto 3: Correo',
    contacto_3_tel: 'Contacto 3: Teléfono',
    direccion_envio: 'Dirección de Envío',
    numero_guia: 'Número de Guía',
    cotizacion_text: 'Texto de Cotización',
    mou_text: 'Texto de MoU',
    buro: 'Autorización Buró',
    terminales_num: 'Número de Terminales',
    tx_mes: 'Transacciones al Mes',
    ventas_anuales: 'Ventas Anuales',
    hora_apertura: 'Hora de Apertura',
    hora_salida: 'Hora de Salida',
    mix_debito: 'Mix Débito',
    mix_credito: 'Mix Crédito',
    mix_intl: 'Mix Internacional',
    web: 'Página Web',
};

const DOC_FRIENDLY_NAMES = {
    acta: 'Acta Constitutiva',
    csf: 'Constancia CSF',
    comprobante: 'Comprobante de Domicilio',
    banco: 'Estado de Cuenta',
    foto_frente: 'Foto Frente Local',
    foto_puerta: 'Foto Puerta Principal',
    foto_interior: 'Foto Interior Local',
    foto_guia: 'Foto de Guía de Envío',
};

export function getFieldFriendlyName(key) {
    return FIELD_FRIENDLY_NAMES[key] || key;
}

export function getDocFriendlyName(type) {
    return DOC_FRIENDLY_NAMES[type] || type;
}

export function getElementTag(documentType) {
    const type = (documentType || '').toLowerCase();
    if (type.includes('form')) return 'form';
    if (type.includes('mou')) return 'mou';
    if (type.includes('cotiza')) return 'cotizacion';
    if (type.includes('contrato')) return 'contrato';
    if (type.includes('send-terminal')) return 'send-terminal';
    if (type.includes('wallet')) return 'wallet';
    return 'oper';
}

export const ELEMENT_TAG_COLORS = {
    form: { bg: 'rgba(59,130,246,0.15)', fg: '#3b82f6' },
    mou: { bg: 'rgba(16,185,129,0.15)', fg: '#10b981' },
    cotizacion: { bg: 'rgba(249,115,22,0.15)', fg: '#f97316' },
    contrato: { bg: 'rgba(139,92,246,0.15)', fg: '#8b5cf6' },
    'send-terminal': { bg: 'rgba(236,72,153,0.15)', fg: '#ec4899' },
};
export const ELEMENT_TAG_DEFAULT_COLOR = { bg: 'rgba(107,114,128,0.15)', fg: '#9ca3af' };
